import { render, staticRenderFns } from "./sportsAdvice.vue?vue&type=template&id=39d990cc&scoped=true&"
import script from "./sportsAdvice.vue?vue&type=script&lang=js&"
export * from "./sportsAdvice.vue?vue&type=script&lang=js&"
import style0 from "./sportsAdvice.vue?vue&type=style&index=0&id=39d990cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d990cc",
  null
  
)

export default component.exports